import * as types from "./actions";

export const login = (user:any) => ({ type: types.LOGIN, user: user });
export const logout = () => ({ type: types.LOGOUT });
export const setStep = (user:any, docs:any) => ({ type: types.SETSTEP, user: user, docs: docs });
export const setDocs = (docs:any) => ({ type: types.SETDOCS, docs: docs });